import React from 'react';
import PropTypes from 'prop-types';
import { AAMBeaconAccordion, AAMBeaconAccordionItem } from 'components/shared/Beacon';

const BeaconAccordion = ({ items, renderItem }) => {
  if (!items || !renderItem) {
    return null;
  }

  return (
    <div id="beacon-root" className="beacon-on-light">
      <div>
        <AAMBeaconAccordion scale="normal">
          {items.map((item, index) => {
            const { title, panel } = renderItem(item);
            return (
              <AAMBeaconAccordionItem key={index}>
                <span slot="title">{title}</span>
                <div slot="panel">{panel}</div>
              </AAMBeaconAccordionItem>
            );
          })}
        </AAMBeaconAccordion>
      </div>
    </div>
  );
};
BeaconAccordion.propTypes = {
    items: PropTypes.array.isRequired,
    renderItem: PropTypes.func.isRequired
};

export default BeaconAccordion;
